import { _axios } from "../../../Utils/Axios/axios";

export const getCurrentUserDataService = async (userToken: string) => {
  return _axios.post(
    "/profile",
    {},
    {
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    }
  );
};
